'use strict';

/* eslint-disable*/
var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper').data('url');

function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper');
}

function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
    } else {
        $suggestionsWrapper.html(response).show();
    }
}

function getSuggestions(scope, e) {
    $.ajax({
        context: scope,
        url: endpoint + encodeURIComponent($(scope).val()),
        method: 'GET',
        success: processResponse,
        error: function () {
            console.error('Error fetching suggestions.');
        }
    });
}


function init () {
    const $modal = $('#search-modal');

    $('.search-icon').click(function (event) {
        event.preventDefault();
        var user = dataLayer.find(o => o.user != null).user;
        var searchObj = $('body').find('input[name="q"]');
        
        if($modal.hasClass('bt-d-none')){
            $modal.removeClass('bt-d-none');
            const modalOffsetTop = $modal.offset().top;
            const scrollTop = $(window).scrollTop();
            if (modalOffsetTop < scrollTop) {
                $('html, body').animate({
                    scrollTop: modalOffsetTop-105
                }, 500);
            }

            $('.header__search__input').focus();

            dataLayer.push({
                'event': 'custom_event',
                'eventCategory': 'search',
                'eventAction': 'go_to_search',
                'eventLabel': 'go to search',//click text
                'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
                'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
                'screenName': 'Search',
                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
                'userId': user.user_id != '' ? user.user_id : ''
            });
        }else{
            $modal.addClass('bt-d-none');
            dataLayer.push({
                'event': 'custom_event',
                'eventCategory': 'search',
                'eventAction': 'cancel_search',
                'eventLabel': 'cancel search',
                'searchTerm': searchObj.val() ? searchObj.val().trim() : '',
                'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
                'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
                'screenName' : 'Search',
                'userType': user.user_id!='' ? 'logged-in' : 'logged-out',
                'userId': user.user_id!='' ? user.user_id : ''
            });
            $('.suggestions-wrapper').hide().empty();
            $('input.header__search__input').val('');
        }
        $('.navbar-brand').removeClass('open');
        $('.navbar-items').removeClass('open');
    });

    function hideSearchModal(event) {
        event.preventDefault();
        $modal.addClass('bt-d-none');
    }
    $('.reset-button').click(hideSearchModal );

    $('.header__search__input').on('input focus', debounce(function (event) {
        event.preventDefault();
        getSuggestions(this);
    }, 300));

    // Clear cached suggestions and modal on form reset
    $('button[type="reset"]').on('click', function () {
        var searchObj = $('body').find('input[name="q"]');
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'search',
            'eventAction': 'cancel_search',
            'eventLabel': 'cancel search',
            'searchTerm': searchObj.val() ? searchObj.val().trim() : '',
            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
            'screenName' : 'Search',
            'userType': user.user_id!='' ? 'logged-in' : 'logged-out',
            'userId': user.user_id!='' ? user.user_id : ''
        });
        $('.suggestions-wrapper').hide().empty();
        $('input.header__search__input').val('');
    });

    $(document).on('click', '.search-suggestion-result', function (e) {
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'search',
            'eventAction': 'search_query_suggestion_click',
            'eventLabel': $(this).text() ? $(this).text().trim() : '',
            'searchTerm': $(this).text() ? $(this).text().trim() : '',
            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
            'screenName' : 'Search',
            'userType': user.user_id!='' ? 'logged-in' : 'logged-out',
            'userId': user.user_id!='' ? user.user_id : ''
        });
    });

    $(document).on('keydown', '.header__search__input', function (e) {
        if (e.keyCode == 13) {
            dataLayer.push({
                'event': 'custom_event',
                'eventCategory': 'search',
                'eventAction': 'search_result',
                'eventLabel': 'search result',
                'searchTerm': $(this).val() ? $(this).val().trim() : '',
                'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
                'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
                'screenName' : 'Search',
                'userType': user.user_id!='' ? 'logged-in' : 'logged-out',
                'userId': user.user_id!='' ? user.user_id : ''
            });
        }
    });

    $(document).on('click', '.header__search__submit', function (e) {
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'search',
            'eventAction': 'search_result',
            'eventLabel': 'search result',
            'searchTerm': $('.header__search__input').val() ? $('.header__search__input').val().trim() : '',
            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
            'screenName' : 'Search',
            'userType': user.user_id!='' ? 'logged-in' : 'logged-out',
            'userId': user.user_id!='' ? user.user_id : ''
        });
    });
}

module.exports = {
    init: init
};


// WEBPACK FOOTER //
// ./cartridges/app_boggi_core/cartridge/js/sections/header/search.js